export function isValidHex(value: string) {
  return !value ? false : RegExp("^#([A-Fa-f0-9]{6})").test(value)
}